/**
 * Active Context Service
 *
 * Provides access to the currently active location in the treasury module.
 * This is populated and synchronized from the ActiveContextProvider in src/shared/hooks/useActiveContext.ts
 */

// Module-level state that gets updated from the ActiveContextProvider
let currentActiveLocationId: string | undefined;

/**
 * Called from the ActiveContextProvider to sync the active location
 * @internal Do not call directly from outside this module
 */
export function setActiveLocationIdInternal(locationId: string | undefined): void {
  currentActiveLocationId = locationId;
}

/**
 * Read the currently active location ID
 * This is synchronized from the global ActiveContextProvider
 */
export function readActiveLocationId(): string | undefined {
  return currentActiveLocationId;
}
